import { render } from "./multiChoice.vue?vue&type=template&id=5a3e471f&scoped=true"
import script from "./multiChoice.vue?vue&type=script&lang=js"
export * from "./multiChoice.vue?vue&type=script&lang=js"

import "./multiChoice.vue?vue&type=style&index=0&id=5a3e471f&scoped=true&lang=css"
import "./multiChoice.vue?vue&type=style&index=1&id=5a3e471f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3e471f"]])

export default __exports__